module.exports = __webpack_public_path__ + "img/334.e8dcf17c.jpg";